import React from "react";
import { QrCodeIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function QrCameraScannerModal({
  isOpen,
  onClose,
  videoRef,
  cameraStream,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in font-sans">
      <style>{`
        @keyframes scan {
          0% { transform: translateY(0); }
          50% { transform: translateY(148px); }
          100% { transform: translateY(0); }
        }
        .animate-scanner-laser {
          animation: scan 2s linear infinite;
        }
      `}</style>
      <div
        className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-sm transform overflow-hidden rounded-3xl bg-slate-900 border border-white/10 p-6 text-center shadow-2xl transition-all">
        <div className="flex items-center justify-between pb-3 border-b border-white/10 mb-4">
          <h3 className="text-sm font-bold text-white flex items-center gap-1.5">
            <QrCodeIcon className="w-5 h-5 text-primary-500 animate-pulse" />
            <span>Scan QR to Check Out</span>
          </h3>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white transition-colors cursor-pointer"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        <div className="relative h-48 w-full bg-black rounded-2xl overflow-hidden border border-white/10 flex items-center justify-center mb-4">
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            className={`w-full h-full object-cover ${!cameraStream ? "hidden" : ""}`}
          />

          {!cameraStream && (
            <div className="flex flex-col items-center justify-center text-slate-500 space-y-2 absolute inset-0">
              <QrCodeIcon className="w-12 h-12 text-slate-700 animate-pulse" />
              <p className="text-[10px] text-slate-400 font-semibold">
                Requesting camera access...
              </p>
            </div>
          )}

          <div className="absolute inset-6 border border-emerald-500/30 rounded-lg pointer-events-none">
            <div className="absolute -top-1 -left-1 w-3 h-3 border-t-2 border-l-2 border-emerald-500" />
            <div className="absolute -top-1 -right-1 w-3 h-3 border-t-2 border-r-2 border-emerald-500" />
            <div className="absolute -bottom-1 -left-1 w-3 h-3 border-b-2 border-l-2 border-emerald-500" />
            <div className="absolute -bottom-1 -right-1 w-3 h-3 border-b-2 border-r-2 border-emerald-500" />
            <div className="absolute top-0 left-0 right-0 h-0.5 bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.8)] animate-scanner-laser" />
          </div>
        </div>

        <div className="space-y-1">
          <p className="text-xs font-bold text-white">Align Site QR Code inside frame</p>
          <p className="text-[10px] text-slate-400 font-medium">
            Scanning starts automatically once aligned.
          </p>
        </div>
      </div>
    </div>
  );
}
